// src/types/ui.types.ts
import type { AdminEntity, AdminRow } from '@/types/administrators.types';
import type { UserRow } from '@/types/users.types';

/* ---------- Modal ---------- */
export type ModalState =
  | null
  | { type: 'createAdmin' }
  | { type: 'editAdmin'; admin: AdminEntity }
  | { type: 'createUser' }
  | { type: 'editUser'; user: UserRow }
  | { type: 'userCreated'; invitationLink: string; otp: string }
  | { type: 'editProfile' }
  | {
      type: 'systemConfirm';
      title: string;
      paragraphs: string[];
      confirmText?: string;
      onConfirm?: () => void;
    };

/* ---------- Confirm ---------- */
export type AdminConfirmKind =
  | 'toggleActive'
  | 'forceLogout'
  | 'forceLoginReset'
  | 'delete';

export type UserConfirmKind =
  | 'userToggleActive'
  | 'userForceLogout'
  | 'userForceLoginReset'
  | 'userDelete';

export type UiConfirmState =
  | { context: 'admins'; kind: AdminConfirmKind; row: AdminRow }
  | { context: 'users'; kind: UserConfirmKind; row: UserRow };

/* ---------- Polling Modal ---------- */
export type PollingModalState =
  | { type: null }
  | {
      type: 'success';
      title?: string;
      message?: string;
      resourceUrl?: string | null;
      details?: Record<string, unknown> | null;
    }
  | {
      type: 'error';
      title?: string;
      message?: string;
      resourceUrl?: string | null;
      details?: Record<string, unknown> | null;
    };

/* ---------- State ---------- */
export interface UiState {
  modal: ModalState;
  confirm: UiConfirmState | null;
  showLoader: boolean;
  errorMessage: string | null;
  pollingModal: PollingModalState;
}

export const initialUiState: UiState = {
  modal: null,
  confirm: null,
  showLoader: false,
  errorMessage: null,
  pollingModal: { type: null },
};
